import { AlertCircle } from 'lucide-react';

import { cn } from '@/shared/utils/cn/cn.util';

import { FORM_LEGEND_INVALID_CLASSES, FORM_LEGEND_TEXT_CLASSES } from '../dynamic-form.tokens';

import { type FormLegendLabelProps } from './FormLegendLabel.types';

/**
 * What a `<legend>` says: the group's name, and whether the group is refusing.
 *
 * Its own component because three legends now need the identical treatment — a
 * plain section, a collapsible one whose legend also holds the disclosure, and
 * an object group — and "the invalid group turns red and grows an icon" is
 * exactly the kind of detail that ends up applied in two of the three.
 *
 * The icon is `aria-hidden`: the group's own error message is what a screen
 * reader announces, and a second "alert circle" announcement would be noise on
 * top of it.
 */
export function FormLegendLabel({ title, isInvalid = false }: FormLegendLabelProps) {
  return (
    <>
      <span className={cn(FORM_LEGEND_TEXT_CLASSES, isInvalid && FORM_LEGEND_INVALID_CLASSES)}>
        {title}
      </span>
      {isInvalid ? (
        <AlertCircle aria-hidden className={cn('h-4 w-4 shrink-0', FORM_LEGEND_INVALID_CLASSES)} />
      ) : null}
    </>
  );
}
